export const en = {
  taskSent: 'Task sent.',
  removeLink: 'Remove link',
  returnedError: 'returned an error.',
  unlink: 'Unlink',
  confirmRemove: 'Really remove?',
  removeError: 'The task link could not be removed. Please try again.'
};

export type Translations = typeof en;
